import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  ApprovalWorkflow,
  CommonReducerAction,
} from "../../../../../../Actions/commonAction";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import createstore from "../../../../../../store";
import SelectList from "../../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});
class LeaveWorkflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isskippable: false,
      approvalworkflowpolicyid: this.props.approvalworkflowpolicyid,
      value: 0,
      expanded01: false,
      expanded02: false,
      expanded03: false,
      expanded04: false,
      expanded05: false,
      expanded06: true,
      expanded07: false,
      expanded08: false,
      expanded09: false,
      expanded10: true,
      Employees: ["1"],
      dropdown: [
        { displayvalue: 1, displayname: "Employee First" },
        { displayvalue: 2, displayname: "Employee Second" },
      ],
      levelEmp: [],
      isselfapproval: true,
      approverTypes: [],
      employeeList: [],
      escalationActionType: [],
      escalationdays: "",
      onapproverchange: 2,
      escalationactiontypeid: "",
      selectedEscalationActionType: {},
      backupemployeeid: "",
      selectedBackupEmployeeId: {},
      approvalworkflowtypeid: null,
      approvertypeids: [],
      selectedApproverTypeIds: [],
      employeeIds: [],
      selectedEmployeeIds: "",
      selectedEmployee: {},
      employeeid: "",
      LevelWiseData: [
        {
          levelName: "Level-1",
          levelId: 1,
          employeeId: "",
          approverTypeIds: [],
          selectedApproverTypeIds: [],
          selectedEmployee: "",
        },
      ],
      approvalworkflowdetailid: "",
      showEmployeeList: false,
      shouldWeUseSamePolicy: 2,
      bemployeeIds: [],
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.GetApproverType();
    this.GetEscalationActionType();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    this.setState({ accountid, subscriptionid }, () => {
      this.GetEmployeeList();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  handleExpandClick01 = () => {
    this.setState((state) => ({
      expanded01: !state.expanded01,
      expanded02: false,
      expanded03: false,
      expanded04: false,

      approvalworkflowtypeid: 4,
      showEmployeeList: false,
      employeeIds: [],
      selectedEmployeeIds: "",
      selectedApproverTypeIds: [],
      approvertypeids: [],
      LevelWiseData: [],
      ErApprovalworkflowtype: false,
      ErApprovalType: false,
      ErEmployees: false,
      ErLevelWiseData: false,
      ErLevelWiseApproverType: false,
      ErLevelWiseEmp: false,
    }));
  };

  handleExpandClick02 = () => {
    this.setState((state) => ({
      expanded02: !state.expanded02,
      expanded01: false,
      expanded03: false,
      expanded04: false,

      approvalworkflowtypeid: 1,
      showEmployeeList: false,
      employeeIds: [],
      selectedEmployeeIds: "",
      selectedApproverTypeIds: [],
      approvertypeids: [],
      LevelWiseData: [],
      ErApprovalworkflowtype: false,
      ErApprovalType: false,
      ErEmployees: false,
      ErLevelWiseData: false,
      ErLevelWiseApproverType: false,
      ErLevelWiseEmp: false,
    }));
  };

  handleExpandClick03 = () => {
    this.setState((state) => ({
      expanded03: !state.expanded03,
      expanded01: false,
      expanded02: false,
      expanded04: false,

      approvalworkflowtypeid: 2,
      showEmployeeList: false,
      employeeIds: [],
      selectedEmployeeIds: "",
      selectedApproverTypeIds: [],
      approvertypeids: [],
      LevelWiseData: [],
      ErApprovalworkflowtype: false,
      ErApprovalType: false,
      ErEmployees: false,
      ErLevelWiseData: false,
      ErLevelWiseApproverType: false,
      ErLevelWiseEmp: false,
    }));
  };

  handleExpandClick04 = () => {
    this.setState((state) => ({
      expanded04: !state.expanded04,
      expanded01: false,
      expanded02: false,
      expanded03: false,

      approvalworkflowtypeid: 3,
      showEmployeeList: false,
      employeeIds: [],
      selectedEmployeeIds: "",
      selectedApproverTypeIds: [],
      approvertypeids: [],
      LevelWiseData: [],
      ErApprovalworkflowtype: false,
      ErApprovalType: false,
      ErEmployees: false,
      ErLevelWiseData: false,
      ErLevelWiseApproverType: false,
      ErLevelWiseEmp: false,
    }));
  };

  handleExpandClick05() {
    this.setState({ expanded05: true, expanded06: false });
  }

  handleExpandClick06() {
    this.setState({
      expanded05: false,
      expanded06: true,
      escalationactiontypeid: "",
      escalationdays: "",
      selectedEscalationActionType: "",
      ErEscalationActionType: false,
      ErEscalationdays: false,
    });
  }

  handleExpandClick09() {
    this.setState({
      expanded09: true,
      ErIsselfapproval: false,
      isselfapproval: false,
      expanded10: false,
    });
  }

  handleExpandClick10() {
    this.setState({
      expanded09: false,
      ErIsselfapproval: false,
      isselfapproval: true,
      expanded10: true,
      backupemployeeid: "",
      selectedBackupEmployeeid: {},
    });
  }

  updateAutoworkflow(selectedIndex) {
    this.setState({ selectedAutoworkflow: selectedIndex.displayvalue });
  }

  updateApproverchange(selectedIndex) {
    this.setState({
      onapproverchange: selectedIndex.displayvalue,
      ErOnapproverchange: false,
    });
  }

  UpdateEmployeeIds(selectedItems) {
    const employeeIds = [];
    for (const item of selectedItems) {
      employeeIds.push(item.displayvalue);
    }
    this.setState({
      employeeIds,
      selectedEmployeeIds: selectedItems,
      ErEmployees: false,
    });
  }

  UpdateApprovertypeIds(selectedItems) {
    const approvertypeids = [];
    let showEmployeeList = false;
    for (const item of selectedItems) {
      if (item.displayvalue) {
        approvertypeids.push(item.displayvalue);
      }
    }
    for (const item of selectedItems) {
      if (parseInt(item.displayvalue) === 3) {
        showEmployeeList = true;
      }
    }
    this.setState({
      approvertypeids,
      selectedApproverTypeIds: selectedItems,
      showEmployeeList,
      ErApprovalType: false,
    });
  }

  UpdateApprovertypeIdsForLevel(index, selectedItems) {
    const { LevelWiseData } = this.state;
    LevelWiseData[index].approverTypeIds = [];
    LevelWiseData[index].selectedApproverTypeIds = selectedItems;
    LevelWiseData[index].showEmployeeList = false;
    for (const item of selectedItems) {
      if (parseInt(item.displayvalue) === 3) {
        LevelWiseData[index].showEmployeeList = true;
      }
      if (item.displayvalue) {
        LevelWiseData[index].approverTypeIds.push(item.displayvalue);
      }
    }

    this.setState({ LevelWiseData, ErLevelWiseApproverType: false });
  }

  UpdateEmployee(index, selectedItem) {
    const { LevelWiseData } = this.state;
    LevelWiseData[index].employeeId = selectedItem.displayvalue;
    LevelWiseData[index].selectedEmployee = selectedItem;
    this.setState({ LevelWiseData, ErLevelWiseEmp: false });
  }

  OnPlus() {
    const { LevelWiseData } = this.state;
    if (LevelWiseData.length < 5) {
      const { length } = LevelWiseData;
      const obj = {
        levelName: `Level-${length + 1}`,
        levelId: length + 1,
        employeeId: "",
        approverTypeIds: [],
        selectedApproverTypeIds: [],
        selectedEmployee: "",
        DuplicateSelection: false,
      };
      LevelWiseData.push(obj);
      this.setState({ LevelWiseData });
    }
  }

  OnMinus() {
    const { LevelWiseData } = this.state;
    const { length } = LevelWiseData;
    LevelWiseData.pop(length);
    this.setState({ LevelWiseData });
  }

  UpdateBackupEmployeeId(selectedItem) {
    const backupemployeeid = selectedItem.displayvalue;
    this.setState({
      backupemployeeid,
      selectedBackupEmployeeid: selectedItem,
      ErBackupEmployee: false,
    });
  }

  UpdateEscalationActionType(selectedItem) {
    this.setState({
      escalationactiontypeid: selectedItem.displayvalue,
      selectedEscalationActionType: selectedItem,
      ErEscalationactiontype: false,
    });
  }

  UpdateDays(event) {
    let escalationdays;
    if (
      event.target.value < 1 ||
      Number.isNaN(event.target.value) ||
      parseInt(event.target.value) > 366
    ) {
      escalationdays = "";
    } else {
      escalationdays = event.target.value;
    }
    this.setState({ escalationdays, ErEscalationdays: false });
  }

  GetEmployeeList() {
    const data = {
      accountid: this.state.accountid,
      statusid: null,
      subscriptionid: this.state.subscriptionid,
      featurekey: "approvalWorkflow",
    };
    const URL = `subscription/getemployeelist`;
    // let URL = `subscription/getemployeelist/${this.state.accountid}/${this.state.subscriptionid}`
    instance
      .post(URL, data)
      .then((result) => {
        let employeeList = [];
        result.data.result.length > 0
          ? (employeeList = result.data.result)
          : (employeeList = []);
        this.setState({ employeeList }, () => {
          const approvalworkflowInfo = this.props.approvalWorkflowReducer;
          if (approvalworkflowInfo.approvalworkflowdetail) {
            const index = approvalworkflowInfo.approvalworkflowdetail.findIndex(
              (x) => parseInt(x.workflowfortypeid) === 3,
            );
            if (index > -1) {
              const ReducerDetails =
                approvalworkflowInfo.approvalworkflowdetail;
              this.setState({ ReducerDetails }, () => {
                setTimeout(() => {
                  this.AssignDetails();
                }, 500);
              });
            } else {
              setTimeout(() => {
                this.GetApprovalWorkflowPolicyDetails();
              }, 500);
            }
          } else {
            setTimeout(() => {
              this.GetApprovalWorkflowPolicyDetails();
            }, 500);
          }
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetApproverType() {
    instance
      .get("superuser/getmastercode/ApproverType")
      .then((result) => {
        let approverTypes = [];
        if (result.data.result.length != 0) {
          console.log("result.data.result: ", result.data.result);
          const tempindex = result.data.result.findIndex(
            (x) => x.displayname == "Secondary Manager",
          );
          if (tempindex != -1) {
            result.data.result[tempindex].displayname = "Additional Manager";
          }
          approverTypes = result.data.result;
        }

        this.setState({ approverTypes });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetEscalationActionType() {
    instance
      .get("superuser/getmastercode/EscalationActionType")
      .then((result) => {
        let escalationActionType = [];
        result.data.result.length > 0
          ? (escalationActionType = result.data.result)
          : (escalationActionType = []);
        this.setState({ escalationActionType });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetApprovalWorkflowPolicyDetails() {
    if (this.state.approvalworkflowpolicyid) {
      const URL = `/subscription/approvalworkflowpolicydetails/${this.state.approvalworkflowpolicyid}`;
      instance
        .get(URL)
        .then((result) => {
          const Details = result.data.result;
          this.setState({ Details }, () => {
            this.AssignDetails();
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  ShouldWeUseSamePolicy(selectedItem) {
    if (parseInt(selectedItem.displayvalue) === 1) {
      this.AssignAttendancePolicy();
    }
    if (parseInt(selectedItem.displayvalue) === 3) {
      this.ClearPolicy();
    }
    this.setState({ shouldWeUseSamePolicy: selectedItem.displayvalue });
  }

  AssignAttendancePolicy() {
    const approvalworkflowInfo = this.props.approvalWorkflowReducer;
    if (approvalworkflowInfo.approvalworkflowdetail) {
      const reducerIndex =
        approvalworkflowInfo.approvalworkflowdetail.findIndex(
          (x) => parseInt(x.workflowfortypeid) === 1,
        );
      if (reducerIndex > -1) {
        let data = approvalworkflowInfo.approvalworkflowdetail[reducerIndex];
        data = JSON.parse(JSON.stringify(data));
        const leaveData = data;
        leaveData.workflowfortypeid = 3;

        const leaveIndex =
          approvalworkflowInfo.approvalworkflowdetail.findIndex(
            (x) => parseInt(x.workflowfortypeid) === 3,
          );
        if (leaveIndex > -1) {
          approvalworkflowInfo.approvalworkflowdetail[leaveIndex]
            .approvalworkflowdetailid != null
            ? (leaveData.approvalworkflowdetailid =
                approvalworkflowInfo.approvalworkflowdetail[
                  leaveIndex
                ].approvalworkflowdetailid)
            : (leaveData.approvalworkflowdetailid = 0);
          if (leaveData.approverdetail.length > 0) {
            leaveData.approverdetail.map((approverdata, index) => {
              approvalworkflowInfo.approvalworkflowdetail[leaveIndex]
                .approvalworkflowdetailid != null
                ? (approverdata.approvalworkflowdetailid =
                    approvalworkflowInfo.approvalworkflowdetail[
                      leaveIndex
                    ].approvalworkflowdetailid)
                : (approverdata.approvalworkflowdetailid = 0);
              approverdata.approverdetailid = 0;
            });
          }
          approvalworkflowInfo.approvalworkflowdetail[leaveIndex] = leaveData;
        } else {
          leaveData.approvalworkflowdetailid = 0;
          approvalworkflowInfo.approvalworkflowdetail.push(leaveData);
        }
        const ReducerDetails = approvalworkflowInfo.approvalworkflowdetail;
        this.setState({ ReducerDetails }, () => {
          setTimeout(() => {
            this.AssignDetails();
          }, 500);
        });
      } else {
        this.props.enqueueSnackbar("Define HRIS workflow policy", {
          variant: "error",
        });
      }
    } else {
      this.props.enqueueSnackbar("Define HRIS workflow policy", {
        variant: "error",
      });
    }
  }

  ClearPolicy() {
    const approvalworkflowInfo = this.props.approvalWorkflowReducer;
    if (approvalworkflowInfo.approvalworkflowdetail) {
      const leaveIndex = approvalworkflowInfo.approvalworkflowdetail.findIndex(
        (x) => parseInt(x.workflowfortypeid) === 3,
      );
      if (leaveIndex > -1) {
        approvalworkflowInfo.approvalworkflowdetail.splice(leaveIndex, 1);
      }
    }
    this.props.ApprovalWorkflow({ ...approvalworkflowInfo });
    this.setState({
      approvalworkflowpolicyid: this.props.approvalworkflowpolicyid,
      value: 0,
      expanded01: false,
      expanded02: false,
      expanded03: false,
      expanded04: false,
      expanded05: false,
      expanded06: false,
      expanded07: false,
      expanded08: false,
      expanded09: false,
      expanded10: false,
      Employees: ["1"],
      levelEmp: [],
      isselfapproval: false,
      escalationdays: "",
      onapproverchange: "",
      escalationactiontypeid: "",
      selectedEscalationActionType: {},
      backupemployeeid: "",
      selectedBackupEmployeeId: {},
      approvalworkflowtypeid: null,
      approvertypeids: [],
      selectedApproverTypeIds: [],
      employeeIds: [],
      selectedEmployeeIds: "",
      selectedEmployee: {},
      employeeid: "",
      LevelWiseData: [
        {
          levelName: "Level-1",
          levelId: 1,
          employeeId: "",
          approverTypeIds: [],
          selectedApproverTypeIds: [],
          selectedEmployee: "",
        },
      ],
      approvalworkflowdetailid: "",
      showEmployeeList: false,
      shouldWeUseSamePolicy: 2,
    });
  }

  AssignDetails() {
    let approvalWorkFlowDetailPolicy = [];
    let approverDetail = [];
    let approvalworkflowdetail = [];
    const approvalworkflowInfo = this.props.approvalWorkflowReducer;
    if (this.state.ReducerDetails) {
      approvalWorkFlowDetailPolicy = this.state.ReducerDetails;
      const index = this.state.ReducerDetails.findIndex(
        (x) => parseInt(x.workflowfortypeid) === 3,
      );
      index > -1
        ? (approverDetail = this.state.ReducerDetails[index].approverdetail)
        : (approverDetail = []);
      const index1 =
        this.props.approvalWorkflowReducer.approvalworkflowdetail.findIndex(
          (x) => x.workflowfortypeid == 3,
        );
      if (index1 > -1) {
        approvalworkflowdetail = [
          ...new Set(
            approvalworkflowInfo.approvalworkflowdetail[index1].approverdetail,
          ),
        ];
        console.log("approvalworkflowdetail: ", approvalworkflowdetail);
      }
      approvalworkflowdetail.map(
        (x1) =>
          (x1.approvertypeid = Number.isInteger(x1.approvertypeid)
            ? x1.approvertypeid
            : x1.approvertypeid == "Department Head"
            ? 4
            : x1.approvertypeid == "Primary Manager"
            ? 1
            : x1.approvertypeid == "Secondary Manager"
            ? 2
            : x1.approvertypeid == "Additional Employee"
            ? 3
            : x1.approvertypeid == "Business Unit Head"
            ? 5
            : null),
      );
      const newindex = approvalworkflowInfo.approvalworkflowdetail.findIndex(
        (x) => x.workflowfortypeid == 3,
      );
      if (newindex > -1) {
        approvalworkflowInfo.approvalworkflowdetail[newindex].approverdetail =
          approvalworkflowdetail;
      }
      console.log("approvalworkflowdetail: ", approvalworkflowdetail);
    } else {
      approvalWorkFlowDetailPolicy =
        this.state.Details.approvalWorkFlowDetailPolicy;
      approverDetail = this.state.Details.approverDetail;
    }
    approvalWorkFlowDetailPolicy.map((data) => {
      if (parseInt(data.workflowfortypeid) === 3) {
        const approvalworkflowdetailid =
          data.approvalworkflowdetailid != null
            ? data.approvalworkflowdetailid
            : 0;
        const { approvalworkflowpolicyid } = data;
        const { workflowfortypeid } = data;
        const { isselfapproval } = data;
        const { backupemployeeid } = data;
        const selectedBackupEmployeeid = this.state.employeeList.find(
          (x) => parseInt(x.displayvalue) === parseInt(data.backupemployeeid),
        );
        const { escalationdays } = data;
        const { escalationactiontypeid } = data;
        const { onapproverchange } = data;
        const { approvalworkflowtypeid } = data;
        let expanded01 = false;
        let expanded02 = false;
        let expanded03 = false;
        let expanded04 = false;
        let expanded05 = false;
        let expanded06 = false;
        let expanded10 = false;
        let expanded09 = false;
        let showEmployeeList;
        if (parseInt(data.approvalworkflowtypeid) == 4) {
          expanded01 = true;
        }
        if (parseInt(data.approvalworkflowtypeid) == 1) {
          expanded02 = true;
        }
        if (parseInt(data.approvalworkflowtypeid) == 2) {
          expanded03 = true;
        }
        if (parseInt(data.approvalworkflowtypeid) == 3) {
          expanded04 = true;
        }
        data.escalationdays ? (expanded05 = true) : (expanded06 = true);
        const selectedEscalationActionType =
          this.state.escalationActionType.find(
            (x) => x.displayvalue == data.escalationactiontypeid,
          );
        if (data.isselfapproval) {
          expanded10 = true;
        }
        if (!data.isselfapproval) {
          expanded09 = true;
        }
        const approvertypeids = [];
        const selectedApproverTypeIds = [];
        const employeeIds = [];
        const selectedEmployeeIds = [];
        const LevelWiseData = [];
        const tempindex = approverDetail.findIndex(
          (info) => info.approvertypeid == "Secondary Manager",
        );
        if (tempindex != -1) {
          approverDetail[tempindex].approvertypeid = "Additional Manager";
        }
        if (parseInt(data.approvalworkflowtypeid) !== 3) {
          approverDetail.map((info) => {
            if (
              parseInt(info.approvalworkflowdetailid) ===
              parseInt(approvalworkflowdetailid)
            ) {
              const selectedApprover = this.state.approverTypes.find(
                (x) =>
                  x.displayname == info.approvertypeid ||
                  x.displayvalue == info.approvertypeid,
              );
              if (selectedApprover) {
                selectedApprover.approvalworkflowdetailid =
                  approvalworkflowdetailid;
                selectedApprover.approverdetailid = info.approverdetailid;
              }
              if (!approvertypeids.find((x) => x == info.approvertypeid)) {
                // this.state.approvalworkflowdetailid ? selectedApproverTypeIds.push(info.approvertypeid) : selectedApproverTypeIds.push(selectedApprover);
                selectedApproverTypeIds.push(selectedApprover);
                approvertypeids.push(info.approvertypeid);
              }
              if (
                parseInt(info.approvertypeid) === 3 ||
                info.approvertypeid == "Additional Employee"
              ) {
                showEmployeeList = true;
                const selectedEmployee = this.state.employeeList.find(
                  (x) => parseInt(x.displayvalue) === info.employeeid,
                );
                // selectedEmployeeIds.push(selectedEmployee);
                // employeeIds.push(info.employeeid);
                const obj = selectedEmployeeIds.find(
                  (x) => x.displayvalue == selectedEmployee.displayvalue,
                );
                if (!obj) {
                  selectedEmployeeIds.push(selectedEmployee);
                }
                // selectedEmployeeIds.push(selectedEmployee);
                const obj1 = employeeIds.find((x) => x == info.employeeid);
                if (!obj1) {
                  employeeIds.push(info.employeeid);
                }
              }
            }
          });
        } else {
          const uniqueLevels = [];
          approverDetail.map((info, index) => {
            if (uniqueLevels.indexOf(info.levelid) === -1) {
              uniqueLevels.push(info.levelid);
            }
          });
          uniqueLevels.map((level, index) => {
            const obj = {
              levelName: "",
              levelId: "",
              approverTypeIds: [],
              selectedApproverTypeIds: [],
              selectedEmployee: "",
              employeeId: "",
            };
            approverDetail.map((info, index) => {
              if (
                parseInt(info.approvalworkflowdetailid) ===
                  parseInt(approvalworkflowdetailid) &&
                info.approvertypeid &&
                parseInt(level) === parseInt(info.levelid)
              ) {
                const selectedApprover = this.state.approverTypes.find(
                  (x) =>
                    parseInt(x.displayvalue) === parseInt(info.approvertypeid),
                );
                selectedApprover.approverdetailid = info.approverdetailid;
                if (
                  !obj.approverTypeIds.find((x) => x == info.approvertypeid)
                ) {
                  obj.selectedApproverTypeIds.push(selectedApprover);
                  obj.approverTypeIds.push(info.approvertypeid);
                }
                obj.approverdetailid = info.approverdetailid;
                obj.approvalworkflowdetailid = approvalworkflowdetailid;
                obj.levelName = `Level-${info.levelid}`;
                obj.levelId = info.levelid;
                if (parseInt(info.approvertypeid) === 3) {
                  obj.showEmployeeList = true;
                  obj.selectedEmployee = this.state.employeeList.find(
                    (x) =>
                      parseInt(x.displayvalue) === parseInt(info.employeeid),
                  );
                  obj.employeeId = info.employeeid;
                }
              }
            });
            LevelWiseData.push(obj);
          });
        }
        this.setState({
          approvalworkflowdetailid,
          approvalworkflowpolicyid,
          workflowfortypeid,
          approvalworkflowtypeid,
          isselfapproval,
          backupemployeeid,
          selectedBackupEmployeeid,
          escalationdays,
          escalationactiontypeid,
          onapproverchange,
          expanded01,
          expanded02,
          expanded03,
          expanded04,
          expanded05,
          expanded06,
          expanded10,
          expanded09,
          selectedEscalationActionType,
          showEmployeeList,
          approvertypeids,
          selectedApproverTypeIds,
          selectedEmployeeIds,
          employeeIds,
          bemployeeIds: employeeIds,
          LevelWiseData,
          // }, () => {
          //                         this.UpdateApprovalWorkFlowReducer();
          //                     });
          //             }
        });
      }
    });
  }

  Validate() {
    let isValid = true;
    let ErApprovalworkflowtype = false;
    let ErApprovalType = false;
    let ErEmployees = false;
    let ErLevelWiseData = false;
    let ErLevelWiseApproverType = false;
    let ErLevelWiseEmp = false;
    let ErIsselfapproval = false;
    let ErBackupEmployee = false;
    let ErEscalationdays = false;
    let ErEscalationactiontype = false;
    let ErOnapproverchange = false;
    if (!this.state.approvalworkflowtypeid) {
      ErApprovalworkflowtype = true;
      this.setState({ ErApprovalworkflowtype });
      this.props.enqueueSnackbar("Please Select Approval Workflow Type", {
        variant: "error",
      });
      return (isValid = false);
    }
    if (parseInt(this.state.approvalworkflowtypeid) !== 4) {
      ErApprovalworkflowtype = false;
      this.setState({ ErApprovalworkflowtype });
      if (parseInt(this.state.approvalworkflowtypeid) !== 3) {
        if (this.state.approvertypeids.length === 0) {
          ErApprovalType = true;
          this.setState({ ErApprovalType });
          this.props.enqueueSnackbar("Please Select Approver", {
            variant: "error",
          });
          return (isValid = false);
        }
        ErApprovalType = false;
        this.setState({ ErApprovalType });
        const arr = this.state.approvertypeids.filter((y) => parseInt(y) === 3);
        if (arr.length !== 0 && this.state.employeeIds.length === 0) {
          ErEmployees = true;
          this.setState({ ErEmployees });
          this.props.enqueueSnackbar("Please Select Employee", {
            variant: "error",
          });
          return (isValid = false);
        }
        ErEmployees = false;
        this.setState({ ErEmployees });
      } else {
        if (this.state.LevelWiseData.length === 0) {
          ErLevelWiseData = true;
          this.setState({ ErLevelWiseData });
          this.props.enqueueSnackbar("Please add employees", {
            variant: "error",
          });
          return (isValid = false);
        }

        ErLevelWiseData = false;
        this.setState({ ErLevelWiseData });
        this.state.LevelWiseData.map((info, index) => {
          if (info.approverTypeIds.length === 0) {
            ErLevelWiseApproverType = true;
            this.setState({ ErLevelWiseApproverType });
            this.props.enqueueSnackbar("Please Select Approver", {
              variant: "error",
            });
            return (isValid = false);
          }
          ErLevelWiseApproverType = false;
          this.setState({ ErLevelWiseApproverType });
          const arr = info.approverTypeIds.filter((y) => parseInt(y) === 3);
          if (arr.length !== 0 && !info.employeeId) {
            ErLevelWiseEmp = true;
            this.setState({ ErLevelWiseEmp });
            this.props.enqueueSnackbar("Please Select Employee", {
              variant: "error",
            });
            return (isValid = false);
          }
          ErLevelWiseEmp = false;
          this.setState({ ErLevelWiseEmp });
        });
      }
    }

    if (
      !this.state.expanded09 &&
      !this.state.expanded10 &&
      this.state.expanded01 == false
    ) {
      ErIsselfapproval = true;
      this.setState({ ErIsselfapproval });
      this.props.enqueueSnackbar("Please select back-up decision maker", {
        variant: "error",
      });
      return (isValid = false);
    }
    ErIsselfapproval = false;
    this.setState({ ErIsselfapproval });

    if (!this.state.isselfapproval && this.state.expanded01 == false) {
      if (!this.state.backupemployeeid) {
        ErBackupEmployee = true;
        this.setState({ ErBackupEmployee });
        this.props.enqueueSnackbar("Please select back-up decision employee", {
          variant: "error",
        });
        return (isValid = false);
      }
      ErBackupEmployee = false;
      this.setState({ ErBackupEmployee });
    } else {
      ErBackupEmployee = false;
      this.setState({ ErBackupEmployee });
    }
    if (this.state.expanded05) {
      if (!this.state.escalationdays) {
        ErEscalationdays = true;
        this.setState({ ErEscalationdays });
        this.props.enqueueSnackbar("Please select escalation days", {
          variant: "error",
        });
        return (isValid = false);
      }
      ErEscalationdays = false;
      this.setState({ ErEscalationdays });

      if (!this.state.escalationactiontypeid) {
        ErEscalationactiontype = true;
        this.setState({ ErEscalationactiontype });
        this.props.enqueueSnackbar("Please select escalation action", {
          variant: "error",
        });
        return (isValid = false);
      }
      ErEscalationactiontype = false;
      this.setState({ ErEscalationactiontype });
    }
    if (!this.state.onapproverchange) {
      ErOnapproverchange = true;
      this.setState({ ErOnapproverchange });
      this.props.enqueueSnackbar(
        "Please select how do you want to handle requests after change of manager/approval",
        { variant: "error" },
      );
      return (isValid = false);
    }
    ErOnapproverchange = false;
    this.setState({ ErOnapproverchange });

    return isValid;
  }

  UpdateApprovalWorkFlowReducer() {
    const approvalworkflowdetail = this.props.approvalWorkflowReducer;
    approvalworkflowdetail.approvalleaveworkflowpolicyid = this.state
      .approvalworkflowtypeid
      ? this.state.approvalworkflowtypeid
      : null;
    approvalworkflowdetail.approvalleaveworkflowisskip = this.state.isskippable;
    this.props.ApprovalWorkflow({ ...approvalworkflowdetail });
    const aprwork =
      this.props.approvalWorkflowReducer.approvalworkflowdetail &&
      this.props.approvalWorkflowReducer.approvalworkflowdetail.find(
        (apr) => apr.workflowfortypeid == 3,
      );
    if (!this.Validate()) {
      // this.props.enqueueSnackbar('Please select all required fields', { variant: 'error' });
      this.props.setTabValue("L");
    } else {
      let data;
      data = {
        approvalworkflowdetailid: this.state.approvalworkflowdetailid
          ? this.state.approvalworkflowdetailid
          : 0,
        workflowfortypeid: 3,
        isselfapproval: this.state.isselfapproval,
        backupemployeeid: this.state.backupemployeeid
          ? this.state.backupemployeeid
          : null,
        escalationdays: this.state.escalationdays
          ? this.state.escalationdays
          : null,
        escalationactiontypeid: this.state.escalationactiontypeid
          ? this.state.escalationactiontypeid
          : null,
        onapproverchange: this.state.onapproverchange,
        approvalworkflowtypeid: this.state.approvalworkflowtypeid,
        approverdetail: [],
      };
      this.state.selectedApproverTypeIds.map((approvertype, index) => {
        const approverTypeItem = {
          approvalworkflowdetailid: this.state.approvalworkflowdetailid
            ? this.state.approvalworkflowdetailid
            : 0,
          approverdetailid: approvertype.approverdetailid
            ? approvertype.approverdetailid
            : 0,
          approvertypeid: approvertype.displayvalue,
          employeeid: null,
          levelid: 1,
        };
        if (parseInt(approvertype.displayvalue) === 3) {
          this.state.employeeIds.map((employeeId) => {
            const existemp = this.state.bemployeeIds.find(
              (id) => id == employeeId,
            );
            const getId = (employeeId1) => {
              const x =
                aprwork &&
                aprwork.approverdetail.find(
                  (emp) => emp.employeeid == employeeId1,
                );
              return x.approverdetailid || 0;
            };

            let employeeItem = null;
            if (existemp) {
              employeeItem = {
                approvalworkflowdetailid: this.state.approvalworkflowdetailid
                  ? this.state.approvalworkflowdetailid
                  : 0,
                approverdetailid: getId(employeeId),
                approvertypeid: approvertype && approvertype.displayvalue,
                employeeid: employeeId,
                levelid: 1,
              };
            } else {
              employeeItem = {
                approvalworkflowdetailid: this.state.approvalworkflowdetailid
                  ? this.state.approvalworkflowdetailid
                  : 0,
                approverdetailid: 0,
                approvertypeid: approvertype && approvertype.displayvalue,
                employeeid: employeeId,
                levelid: 1,
              };
            }

            data.approverdetail.push(employeeItem);
          });
        }
        if (parseInt(approvertype.displayvalue) !== 3) {
          data.approverdetail.push(approverTypeItem);
        }
      });
      this.state.LevelWiseData.map((levelData, index) => {
        levelData.selectedApproverTypeIds.map((approvertype, index) => {
          const approverTypeItem = {
            approvalworkflowdetailid: this.state.approvalworkflowdetailid
              ? this.state.approvalworkflowdetailid
              : 0,
            approverdetailid: approvertype.approverdetailid
              ? approvertype.approverdetailid
              : 0,
            approvertypeid: approvertype.displayvalue,
            employeeid: null,
            levelid: levelData.levelId,
          };
          if (parseInt(approvertype.displayvalue) === 3) {
            const employeeItem = {
              approvalworkflowdetailid: this.state.approvalworkflowdetailid
                ? this.state.approvalworkflowdetailid
                : 0,
              approverdetailid: approvertype.approverdetailid
                ? approvertype.approverdetailid
                : 0,
              approvertypeid: approvertype.displayvalue,
              employeeid: levelData.employeeId,
              levelid: levelData.levelId,
            };
            data.approverdetail.push(employeeItem);
          }
          if (parseInt(approvertype.displayvalue) !== 3) {
            data.approverdetail.push(approverTypeItem);
          }
        });
      });
      this.setState({ LeaveWorkflowDetails: data });
      const approvalworkflowInfo = this.props.approvalWorkflowReducer;
      if (approvalworkflowInfo.approvalworkflowdetail) {
        const index = approvalworkflowInfo.approvalworkflowdetail.findIndex(
          (x) =>
            parseInt(x.workflowfortypeid) === parseInt(data.workflowfortypeid),
        );
        index > -1
          ? (approvalworkflowInfo.approvalworkflowdetail[index] = data)
          : approvalworkflowInfo.approvalworkflowdetail.push(data);
      } else {
        approvalworkflowInfo.approvalworkflowdetail = [];
        approvalworkflowInfo.approvalworkflowdetail.push(data);
      }
      this.props.ApprovalWorkflow({ ...approvalworkflowInfo });
      this.props.setTabValue(this.props.nextid);
    }
  }

  OnSave() {
    this.UpdateApprovalWorkFlowReducer();
    // if (!this.Validate) {

    // } else {
    //     this.props.setTabValue(4);
    // }
  }

  Skipandnext() {
    this.setState({ isskippable: true });
    const approvalworkflowdetail = this.props.approvalWorkflowReducer;
    approvalworkflowdetail.approvalleaveworkflowisskip = true;
    this.props.ApprovalWorkflow({ ...approvalworkflowdetail });
    this.props.setTabValue(this.props.nextid);
  }

  render() {
    const autoworkflow = [
      {
        displayvalue: 1,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: 2,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    const approverchange = [
      {
        displayvalue: 1,
        displayname: (
          <FormattedMessage
            id="LbAllRequests"
            defaultMessage="Transfer all requests to the new manager/approval"
          />
        ),
      },
      {
        displayvalue: 2,
        displayname: (
          <FormattedMessage
            id="LbPendingRequests"
            defaultMessage="Transfer only pending requests to new manager/approval"
          />
        ),
      },
    ];
    return (
      <div>
        <div className="width600">
          <div style={{ marginBottom: 16 }}>
            <p className="large-text-dark-secondary t-bold margin-bottom-16">
              Leave Workflow
            </p>
            <p style={{ fontSize: 14, opacity: 0.7 }}>
              This workflow covers leave requests, optional holiday selections,
              and gifting of leaves.
            </p>
          </div>
          {this.props.history.location.pathname.includes("create") && (
            <div>
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbshouldusehrisPolicy"
                  defaultMessage="Should we use the same configurations as HRIS Workflow?"
                />
              </p>
              <SelectList
                data={autoworkflow}
                Selected={this.state.shouldWeUseSamePolicy}
                onSelected={this.ShouldWeUseSamePolicy.bind(this)}
              />
            </div>
          )}
          <div className="margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbTypeofWorkflow"
                defaultMessage="What type of workflow would you like"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={this.handleExpandClick01}
              aria-expanded={this.state.expanded01}
            >
              <span
                style={{
                  fontSize: 14,
                  opacity: 0.7,
                  width: "94%",
                  display: "inline-block",
                }}
              >
                <span style={{ display: "block", fontWeight: "bold" }}>
                  <FormattedMessage
                    id="LbFullTrustWorkflow"
                    defaultMessage="Full-trust workflow"
                  />
                </span>
                <span style={{ fontSize: 14, opacity: 0.7 }}>
                  Selecting this workflow means that all requests will be
                  approved as soon as they're applied. Managers and admins will
                  be notified about the requests, they can revoke the request if
                  they wish to.
                </span>
              </span>
              {this.state.expanded01 ? (
                <span className="floatright">
                  <img src={CheckImg} alt="" height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>
            <div
              className="depedent-select-list "
              onClick={this.handleExpandClick02}
              aria-expanded={this.state.expanded02}
            >
              <span
                style={{
                  fontSize: 14,
                  opacity: 0.7,
                  width: "94%",
                  display: "inline-block",
                }}
              >
                <span style={{ display: "block", fontWeight: "bold" }}>
                  <FormattedMessage
                    id="LbFreeflowingWorkflow"
                    defaultMessage="Free flowing workflow"
                  />
                </span>
                <span style={{ fontSize: 14, opacity: 0.7 }}>
                  In this workflow, any 1 of the recipients can approve the
                  request, irrespective of the number of recipients involved.
                </span>
              </span>
              {this.state.expanded02 ? (
                <span className="floatright">
                  <img alt="" src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>
            {this.state.expanded02 ? <div className="bottom-border"></div> : ""}
            <div className="width550">
              <Collapse
                in={this.state.expanded02}
                timeout="auto"
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <div>
                  <p className="form-input-label">
                    <FormattedMessage
                      id="LbPositionHierarchy"
                      defaultMessage="Select employees based on their position in hierarchy"
                    />
                  </p>
                  <div className="width100">
                    <Select
                      className="selectsearch"
                      onChange={this.UpdateApprovertypeIds.bind(this)}
                      isMulti
                      options={this.state.approverTypes}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={this.state.selectedApproverTypeIds}
                      placeholder="Select Approver"
                    />
                    <div>
                      {this.state.ErApprovalType ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErApprovalType"
                            defaultMessage="Please select approver type"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {this.state.showEmployeeList ? (
                    <div>
                      <p className="add-label-active">
                        <FormattedMessage
                          id="LbSpecificEmployees"
                          defaultMessage="Select certain specific employee who will also receive the request for action"
                        />
                      </p>
                      <div className="width100">
                        <Select
                          className="selectsearch"
                          onChange={this.UpdateEmployeeIds.bind(this)}
                          isMulti
                          options={this.state.employeeList}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.selectedEmployeeIds}
                          placeholder="Select Employee"
                        />
                        <div>
                          {this.state.ErEmployees ? (
                            <span className="caption-error">
                              <FormattedMessage
                                id="ErEmployees"
                                defaultMessage="Please select employee"
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={this.handleExpandClick03}
              aria-expanded={this.state.expanded03}
            >
              <span
                style={{
                  fontSize: 14,
                  opacity: 0.7,
                  width: "94%",
                  display: "inline-block",
                }}
              >
                <span style={{ display: "block", fontWeight: "bold" }}>
                  <FormattedMessage
                    id="LbAllhandsWorkflow"
                    defaultMessage="All-hands-in workflow"
                  />
                </span>
                <span style={{ fontSize: 14, opacity: 0.7 }}>
                  In this workflow, all recipients are required to approve the
                  request. Even if 1 of the recipients doesn&apos;t approve, the
                  request will remain pending. Similarly, even if 1 of the
                  recipients reject the request, the entire request will be
                  rejected irrespective of recipients' approvals.
                </span>
              </span>
              {this.state.expanded03 ? (
                <span className="floatright">
                  <img src={CheckImg} alt="" height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>
            {this.state.expanded03 ? <div className="bottom-border"></div> : ""}
            <div className="width550">
              <Collapse
                in={this.state.expanded03}
                timeout="auto"
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <div>
                  <p className="form-input-label">
                    <FormattedMessage
                      id="LbPositionHierarchy"
                      defaultMessage="Select employees based on their position in hierarchy"
                    />
                  </p>
                  <div className="width100">
                    <Select
                      className="selectsearch"
                      onChange={this.UpdateApprovertypeIds.bind(this)}
                      isMulti
                      options={this.state.approverTypes}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={this.state.selectedApproverTypeIds}
                      placeholder="Select Approver"
                    />
                    <div>
                      {this.state.ErApprovalType ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErApprovalType"
                            defaultMessage="Please select approver type"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {this.state.showEmployeeList ? (
                    <div>
                      <p className="add-label-active">
                        <FormattedMessage
                          id="LbSpecificEmployees"
                          defaultMessage="Select certain specific employee who will also receive the request for action"
                        />
                      </p>
                      <div className="width100">
                        <Select
                          className="selectsearch"
                          onChange={this.UpdateEmployeeIds.bind(this)}
                          isMulti
                          options={this.state.employeeList}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.selectedEmployeeIds}
                          placeholder="Select Employee"
                        />
                        <div>
                          {this.state.ErEmployees ? (
                            <span className="caption-error">
                              <FormattedMessage
                                id="ErEmployees"
                                defaultMessage="Please select employee"
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Collapse>
            </div>
            <div
              className="depedent-select-list bottom-border"
              onClick={this.handleExpandClick04}
              aria-expanded={this.state.expanded04}
            >
              <span
                style={{
                  fontSize: 14,
                  opacity: 0.7,
                  width: "94%",
                  display: "inline-block",
                }}
              >
                <span style={{ display: "block", fontWeight: "bold" }}>
                  <FormattedMessage
                    id="LbLevelbasedWorkflow"
                    defaultMessage="Level-based workflow"
                  />
                </span>
                <span style={{ fontSize: 14, opacity: 0.7 }}>
                  In this workflow, you can create up to 5 levels of approvals.
                  As a request is approved at the first level, it will move to
                  the next level and so on. The request will remain pending
                  until it receives approval on all the levels.
                </span>
              </span>
              {this.state.expanded04 ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>
            <Collapse
              in={this.state.expanded04}
              timeout="auto"
              unmountOnExit
              className="overflow-initial"
            >
              <div>
                <div>
                  {this.state.ErLevelWiseData ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErLevelWiseData"
                        defaultMessage="Please add employee"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {this.state.ErLevelWiseApproverType ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErLevelWiseApproverType"
                        defaultMessage="Please select approver type"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {this.state.ErLevelWiseEmp ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErLevelWiseEmp"
                        defaultMessage="Please select employee"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                {this.state.LevelWiseData.map((data, index) => {
                  data.approverTypes = this.state.approverTypes;
                  const leveltypes = [];
                  for (const level in this.state.LevelWiseData) {
                    if (parseInt(index) !== parseInt(level)) {
                      leveltypes.push(
                        ...this.state.LevelWiseData[level].approverTypeIds,
                      );
                    }
                  }
                  data.approverTypes = data.approverTypes.filter(
                    (x) => !leveltypes.includes(x.displayvalue),
                  );
                  return (
                    <div className="margin-top-20">
                      <p className="form-input-label">
                        {data.levelName} &nbsp; &nbsp;
                        <FormattedMessage
                          id="LbPositionHierarchy"
                          defaultMessage="Select employees based on their position in hierarchy"
                        />
                      </p>
                      <div className="width100">
                        <Select
                          className="selectsearch"
                          onChange={this.UpdateApprovertypeIdsForLevel.bind(
                            this,
                            index,
                          )}
                          isMulti
                          options={data.approverTypes.filter(
                            (x) => x.displayname != "Additional Manager",
                          )}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={data.selectedApproverTypeIds}
                          placeholder="Select Approver"
                        />
                      </div>
                      {data.showEmployeeList ? (
                        <div>
                          <p className="add-label-active">
                            {data.levelName} &nbsp; &nbsp;
                            <FormattedMessage
                              id="LbSpecificEmployees"
                              defaultMessage="Select certain specific employee who will also receive the request for action"
                            />
                          </p>
                          <div className="width100">
                            <Select
                              className="selectsearch"
                              onChange={this.UpdateEmployee.bind(this, index)}
                              options={this.state.employeeList}
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={data.selectedEmployee}
                              placeholder="Select Employee"
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
                <div className="margin-top-20">
                  <p>
                    <span>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.OnPlus.bind(this)}
                      >
                        +
                      </Button>
                    </span>
                    <span className="add-label t-14">
                      <FormattedMessage
                        id="LbAddLevelForApproval"
                        defaultMessage="Add Level for approval"
                      />
                    </span>
                  </p>
                  <p>
                    <span>
                      <Button
                        variant="contained"
                        color="primary"
                        className=""
                        onClick={this.OnMinus.bind(this)}
                      >
                        -
                      </Button>
                    </span>
                    <span className="add-label t-14">
                      <FormattedMessage
                        id="LbRemoveLevelForApproval"
                        defaultMessage="Remove Level for approval"
                      />
                    </span>
                  </p>
                </div>
              </div>
            </Collapse>
            <div>
              {this.state.ErApprovalworkflowtype ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErApprovalworkflowtype"
                    defaultMessage="Please select approver workflow type"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          {this.state.approvalworkflowtypeid != 4 && (
            <div className="padding-top-20">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbAutomaticallyHandleInaction"
                  defaultMessage="Do you want to automatically handle inaction on any request by the selected persons in this workflow?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={this.handleExpandClick05.bind(this)}
                aria-expanded={this.state.expanded05}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.expanded05 ? (
                  <span className="floatright">
                    <img src={CheckImg} alt="" height="20" />
                  </span>
                ) : (
                  <span className="not-selected"></span>
                )}
              </div>
              <Collapse
                in={this.state.expanded05}
                timeout="auto"
                unmountOnExit
                className="overflow-initial"
              >
                <div className="padding20 padding-bottom-0">
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="LbRequestInacted"
                      defaultMessage="Select the number of days you want to accept/reject if request is inacted"
                    />
                  </p>
                  <span className="number-wrapper probation-days">
                    <input
                      className="seatlimit"
                      type="number"
                      min="1"
                      max="366"
                      placeholder="00"
                      onChange={this.UpdateDays.bind(this)}
                      onBlur={this.UpdateDays.bind(this)}
                      value={this.state.escalationdays}
                    />
                  </span>
                  <span>Days</span>
                  <div>
                    {this.state.ErEscalationdays ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErEscalationdays"
                          defaultMessage="Please select escalation days"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="padding20 padding-bottom-10">
                  <p className="form-sub-header">
                    <FormattedMessage
                      id="LbInactionRequest"
                      defaultMessage="Select action for inaction on any request"
                    />
                  </p>
                  <p className="form-input-label">
                    <FormattedMessage
                      id="LbSelectAction"
                      defaultMessage="Select action"
                    />
                  </p>
                  <div className="width100 margin-bottom-20">
                    <Select
                      className="selectsearch"
                      onChange={this.UpdateEscalationActionType.bind(this)}
                      options={this.state.escalationActionType}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={this.state.selectedEscalationActionType}
                      placeholder="Select Action"
                    />
                    <div>
                      {this.state.ErEscalationactiontype ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErEscalationactiontype"
                            defaultMessage="Please select escalationaction type"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </Collapse>
              <div
                className="depedent-select-list bottom-border"
                onClick={this.handleExpandClick06.bind(this)}
                aria-expanded={this.state.expanded06}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.expanded06 ? (
                  <span className="floatright">
                    <img src={CheckImg} alt="" height="20" />
                  </span>
                ) : (
                  <span className="not-selected"></span>
                )}
              </div>
            </div>
          )}
          {this.state.expanded01 == false ? (
            <div>
              {" "}
              <div className="padding-top-20">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbApproversMentioned"
                    defaultMessage="If approvers mentioned above don’t exist for any particular employee (requester),
                            then consider following for back-up decision maker"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={this.handleExpandClick10.bind(this)}
                  aria-expanded={this.state.expanded10}
                >
                  <span>
                    <FormattedMessage
                      id="LbAllowSelfApproval"
                      defaultMessage="Allow Self Approval"
                    />
                  </span>
                  {this.state.expanded10 ? (
                    <span className="floatright">
                      <img src={CheckImg} alt="" height="20" />
                    </span>
                  ) : (
                    <span className="not-selected"></span>
                  )}
                </div>
                <div
                  className="depedent-select-list bottom-border"
                  onClick={this.handleExpandClick09.bind(this)}
                  aria-expanded={this.state.expanded09}
                >
                  <span>
                    <FormattedMessage
                      id="LbDecisionMaker"
                      defaultMessage="Select as a back-up decision maker"
                    />
                  </span>
                  {this.state.expanded09 ? (
                    <span className="floatright">
                      <img src={CheckImg} alt="" height="20" />
                    </span>
                  ) : (
                    <span className="not-selected"></span>
                  )}
                </div>
                <Collapse
                  in={this.state.expanded09}
                  timeout="auto"
                  unmountOnExit
                  className="overflow-initial"
                >
                  <div className="padding20">
                    <p className="form-input-label">
                      <FormattedMessage
                        id="LbSelectBackUp"
                        defaultMessage="Select back-up"
                      />
                    </p>
                    <div className="width100">
                      <Select
                        className="selectsearch"
                        onChange={this.UpdateBackupEmployeeId.bind(this)}
                        options={this.state.employeeList}
                        getOptionLabel={(option) => option.displayname}
                        getOptionValue={(option) => option.displayvalue}
                        value={this.state.selectedBackupEmployeeid}
                        placeholder="Select Employee"
                      />
                      <div>
                        {this.state.ErBackupEmployee ? (
                          <span className="caption-error">
                            <FormattedMessage
                              id="ErBackupEmployee"
                              defaultMessage="Please select backup Employee"
                            />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </Collapse>
                <div>
                  {this.state.ErIsselfapproval ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErIsselfapproval"
                        defaultMessage="Please select backup decision maker"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="padding-top-20">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbChangeOfManager"
                    defaultMessage="How do you want to handle requests after change of manager/approver?"
                  />
                </p>
                <SelectList
                  data={approverchange}
                  Selected={this.state.onapproverchange}
                  onSelected={this.updateApproverchange.bind(this)}
                />
              </div>
              <div>
                {this.state.ErOnapproverchange ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="ErOnapproverchange"
                      defaultMessage="Please select how do you want to handle requests after change of manager/approval"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : null}

          <div className="padding-top-20">
            <Button
              className="btn btn-secondary-md-blue"
              variant="contained"
              color="primary"
              size="large"
              onClick={this.Skipandnext.bind(this)}
            >
              Skip
            </Button>
            <Button
              variant="contained"
              className="btn btn-primary-md-blue margin-left-20"
              color="primary"
              size="large"
              onClick={this.OnSave.bind(this)}
            >
              Save & next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
LeaveWorkflow.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  approvalWorkflowReducer: state.approvalWorkflowReducer,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ApprovalWorkflow: (data) => ApprovalWorkflow(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
    },
    dispatch,
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withSnackbar(LeaveWorkflow))),
);
